(function () {
    'use strict';

    angular
        .module('components.policies', [
            'app.core'
        ]);

})();
